<div class="container" *ngIf='souscription'>
    <app-header></app-header>
    <app-breadcrumb></app-breadcrumb>
    <app-steps></app-steps>
    <router-outlet></router-outlet>
</div>
